/**
 * rotasTelao.js — Quais rotas são telão, e por que isso importa.
 *
 * Os painéis de quadra rodam numa TV do ginásio, sem ninguém operando: a tela
 * inteira é conteúdo. Renderizá-los dentro do portal custa o cabeçalho, o menu,
 * o rodapé com endereço e redes sociais, e os widgets flutuantes (acessibilidade,
 * suporte, VLibras) — perto de 30% da área útil, mais um botão azul sobre a
 * faixa da primeira quadra.
 *
 * Este módulo é a fonte única dessa lista: o roteador a usa para montar as rotas
 * fora do `Layout`, e o `App` a usa para não montar os widgets. Se ficassem em
 * dois lugares, uma rota nova entraria sem `Layout` e continuaria com o botão de
 * acessibilidade por cima — que foi exatamente o sintoma observado.
 *
 * O console de rebalanceamento NÃO entra aqui: ele é ferramenta de operador, com
 * navegação e diálogos, e o portal em volta ajuda em vez de atrapalhar.
 */

/** Sufixos de caminho que identificam uma tela de telão. */
export const ROTAS_TELAO = [
  '/eventos/evento/quadra', // Painel Lista de Disputas (Fase 4)
  '/eventos/evento/chamada', // Painel Chamada de Lutas (Fase 5)
];

/**
 * A rota atual é um telão?
 *
 * Compara por sufixo porque o app roda sob subdomínio (`/fctkd/eventos/...`) e o
 * prefixo varia por federação.
 *
 * @param {string} pathname
 * @returns {boolean}
 */
export function ehRotaTelao(pathname) {
  const caminho = String(pathname ?? '').replace(/\/+$/, '');
  return ROTAS_TELAO.some((rota) => caminho.endsWith(rota));
}
